import { Image } from 'element-ui'

const YImage = Image
YImage.$depends = [Image]
YImage.$name = 'y-image'
YImage._name = 'Image 图片'

export default YImage
